import { apiFetch } from "../useApi";

export default async function userSettings({ settings }) {
  const response = await apiFetch('/me/settings', {
    method: 'PATCH',
    body: JSON.stringify(settings),
  });
  return response.json();
}
